export function useRoomAmenities(amenity: number) {
	const roomAmenitiesList = [
		null,
		{
			name: 'Aire acondicionado',
			icon: 'ac_unit',
		},
		{
			name: 'Reloj despertador',
			icon: 'alarm',
		},
		{
			name: 'Canal de noticias',
			icon: 'rss_feed',
		},
		{
			name: 'Radio AM/FM',
			icon: 'radio',
		},
		{
			name: 'Monitor de bebé',
			icon: 'child_care',
		},
		{
			name: 'Balcón/Terraza',
			icon: 'balcony',
		},
		{
			name: 'Parrillas de barbacoa',
			icon: 'outdoor_grill',
		},
		{
			name: 'Tina con jets',
			icon: 'bathtub',
		},
		{
			name: 'Bata de baño',
			icon: 'bathtub',
		},
		{
			name: 'Amenidades de baño',
			icon: 'bathtub',
		},
		{
			name: 'Teléfono en baño',
			icon: 'phone',
		},
		{
			name: 'Tina de baño',
			icon: 'bathtub',
		},
		{
			name: 'Solo tina de baño',
			icon: 'bathtub',
		},
		{
			name: 'Tina y regadera',
			icon: 'bathtub',
		},
		{
			name: 'Bidé',
			icon: 'bathtub',
		},
		{
			name: 'Agua embotellada',
			icon: 'local_drink',
		},
		{
			name: 'TV por cable/satélite',
			icon: 'tv',
		},
		{
			name: 'Cafetera',
			icon: 'local_cafe',
		},
		{
			name: 'Televisión',
			icon: 'tv',
		},
		{
			name: 'Computadora',
			icon: 'computer',
		},
		{
			name: 'Habitaciones conectadas',
			icon: 'meeting_room',
		},
		{
			name: 'Adaptadores de voltaje',
			icon: 'power',
		},
		{
			name: 'Copiadora',
			icon: 'print',
		},
		{
			name: 'Teléfono inalámbrico',
			icon: 'phone',
		},
		{
			name: 'Cunas',
			icon: 'child_care',
		},
		{
			name: 'Puerto de datos',
			icon: 'router',
		},
		{
			name: 'Escritorio',
			icon: 'desk',
		},
		{
			name: 'Escritorio con lámpara',
			icon: 'desk',
		},
		{
			name: 'Guía de restaurantes',
			icon: 'restaurant',
		},
		{
			name: 'Teléfono con marcación directa',
			icon: 'phone',
		},
		{
			name: 'Lavavajillas',
			icon: 'dishwasher_gen',
		},
		{
			name: 'Camas dobles',
			icon: 'hotel',
		},
		{
			name: 'Enchufe de doble voltaje',
			icon: 'power',
		},
		{
			name: 'Voltaje eléctrico',
			icon: 'power',
		},
		{
			name: 'Silla ergonómica',
			icon: 'chair',
		},
		{
			name: 'Cable de teléfono extendido',
			icon: 'phone',
		},
		{
			name: 'Fax',
			icon: 'print',
		},
		{
			name: 'Alarma de incendio',
			icon: 'fireplace',
		},
		{
			name: 'Alarma de incendio con luz',
			icon: 'fireplace',
		},
		{
			name: 'Chimenea',
			icon: 'fireplace',
		},
		{
			name: 'Llamadas gratuitas sin cargo',
			icon: 'phone',
		},
		{
			name: 'Llamadas gratuitas',
			icon: 'phone',
		},
		{
			name: 'Llamadas gratuitas con tarjeta de crédito',
			icon: 'phone',
		},
		{
			name: 'Llamadas locales gratuitas',
			icon: 'phone',
		},
		{
			name: 'Películas/videos gratuitos',
			icon: 'movie',
		},
		{
			name: 'Cocina completa',
			icon: 'kitchen',
		},
		{
			name: 'Barras de apoyo en baño',
			icon: 'bathtub',
		},
		{
			name: 'Tina estilo griego',
			icon: 'bathtub',
		},
		{
			name: 'Secador de pelo',
			icon: 'hairdryer',
		},
		{
			name: 'Internet de alta velocidad',
			icon: 'wifi',
		},
		{
			name: 'TV interactiva web',
			icon: 'tv',
		},
		{
			name: 'Marcación internacional directa',
			icon: 'phone',
		},
		{
			name: 'Acceso a internet',
			icon: 'wifi',
		},
		{
			name: 'Plancha',
			icon: 'iron',
		},
		{
			name: 'Tabla de planchar',
			icon: 'iron',
		},
		{
			name: 'Jacuzzi',
			icon: 'hot_tub',
		},
		{
			name: 'Cama king size',
			icon: 'hotel',
		},
		{
			name: 'Cocina',
			icon: 'kitchen',
		},
		{
			name: 'Utensilios de cocina',
			icon: 'kitchen',
		},
		{
			name: 'Cocineta',
			icon: 'kitchen',
		},
		{
			name: 'Luz de aviso',
			icon: 'light',
		},
		{
			name: 'Laptop',
			icon: 'computer',
		},
		{
			name: 'Escritorio grande',
			icon: 'desk',
		},
		{
			name: 'Área de trabajo amplia',
			icon: 'desk',
		},
		{
			name: 'Cesto de ropa',
			icon: 'local_laundry_service',
		},
		{
			name: 'Loft',
			icon: 'stairs',
		},
		{
			name: 'Microondas',
			icon: 'microwave',
		},
		{
			name: 'Minibar',
			icon: 'local_bar',
		},
		{
			name: 'Módem',
			icon: 'router',
		},
		{
			name: 'Conexión para módem',
			icon: 'router',
		},
		{
			name: 'Teléfono multilínea',
			icon: 'phone',
		},
		{
			name: 'Periódico',
			icon: 'newspaper',
		},
		{
			name: 'No fumadores',
			icon: 'smoke_free',
		},
		{
			name: 'Blocs de notas',
			icon: 'note',
		},
		{
			name: 'Útiles de oficina',
			icon: 'note',
		},
		{
			name: 'Horno',
			icon: 'oven',
		},
		{
			name: 'Películas de pago por evento',
			icon: 'movie',
		},
		{
			name: 'Plumas',
			icon: 'ink_pen',
		},
		{
			name: 'Teléfono en baño',
			icon: 'phone',
		},
		{
			name: 'Platos y tazones',
			icon: 'kitchen',
		},
		{
			name: 'Ollas y sartenes',
			icon: 'kitchen',
		},
		{
			name: 'Tapetes de oración',
			icon: 'folded_hands',
		},
		{
			name: 'Impresora',
			icon: 'print',
		},
		{
			name: 'Baño privado',
			icon: 'bathtub',
		},
		{
			name: 'Cama queen size',
			icon: 'hotel',
		},
		{
			name: 'Sillón reclinable',
			icon: 'chair',
		},
		{
			name: 'Refrigerador',
			icon: 'kitchen',
		},
		{
			name: 'Refrigerador con fábrica de hielo',
			icon: 'kitchen',
		},
		{
			name: 'TV con control remoto',
			icon: 'tv',
		},
		{
			name: 'Cama plegable',
			icon: 'hotel',
		},
		{
			name: 'Caja fuerte',
			icon: 'verified_user',
		},
		{
			name: 'Escáner',
			icon: 'print',
		},
		{
			name: 'Clóset separado',
			icon: 'checkroom',
		},
		{
			name: 'Línea de módem separada disponible',
			icon: 'router',
		},
		{
			name: 'Lustrador de zapatos',
			icon: 'local_mall',
		},
		{
			name: 'Solo regadera',
			icon: 'shower',
		},
		{
			name: 'Cubertería/utensilios',
			icon: 'kitchen',
		},
		{
			name: 'Área de descanso',
			icon: 'chair',
		},
		{
			name: 'Detectores de humo',
			icon: 'smoke_free',
		},
		{
			name: 'Fumadores',
			icon: 'smoking_rooms',
		},
		{
			name: 'Sofá cama',
			icon: 'hotel',
		},
		{
			name: 'Teléfono con altavoz',
			icon: 'phone',
		},
		{
			name: 'Estéreo',
			icon: 'radio',
		},
		{
			name: 'Estufa',
			icon: 'multicooker',
		},
		{
			name: 'Grabadora',
			icon: 'radio',
		},
		{
			name: 'Teléfono',
			icon: 'phone',
		},
		{
			name: 'Teléfono para personas con discapacidad auditiva',
			icon: 'phone',
		},
		{
			name: 'Teléfonos con luz de mensajes',
			icon: 'phone',
		},
		{
			name: 'Horno tostador',
			icon: 'oven',
		},
		{
			name: 'Prensa para pantalones',
			icon: 'iron',
		},
		{
			name: 'Servicio de preparación nocturna',
			icon: 'hotel',
		},
		{
			name: 'Cama individual',
			icon: 'hotel',
		},
		{
			name: 'Techos altos',
			icon: 'roofing',
		},
		{
			name: 'Películas VCR',
			icon: 'movie',
		},
		{
			name: 'Reproductor VCR',
			icon: 'movie',
		},
		{
			name: 'Videojuegos',
			icon: 'videogame_asset',
		},
		{
			name: 'Correo de voz',
			icon: 'phone',
		},
		{
			name: 'Servicio de despertador',
			icon: 'alarm',
		},
		{
			name: 'Baño completo',
			icon: 'bathroom',
		},
		{
			name: 'Sistema de purificación de agua',
			icon: 'water',
		},
		{
			name: 'Bar húmedo',
			icon: 'kitchen',
		},
		{
			name: 'Internet inalámbrico',
			icon: 'wifi',
		},
		{
			name: 'Teclado inalámbrico',
			icon: 'keyboard',
		},
		{
			name: 'Adaptador disponible para uso de teléfono con PC',
			icon: 'phone',
		},
		{
			name: 'Aire acondicionado con control individual',
			icon: 'ac_unit',
		},
		{
			name: 'Tina y jacuzzi separados',
			icon: 'hot_tub',
		},
		{
			name: 'Teléfono con puertos de datos',
			icon: 'phone',
		},
		{
			name: 'Reproductor de CD',
			icon: 'album',
		},
		{
			name: 'Llamadas locales gratuitas con límite de tiempo',
			icon: 'phone',
		},
		{
			name: 'Cargo extra por persona adicional usando cama plegable',
			icon: 'hotel',
		},
		{
			name: 'Almohadas de plumón',
			icon: 'hotel',
		},
		{
			name: 'Escritorio con enchufe eléctrico',
			icon: 'power',
		},
		{
			name: 'ESPN disponible',
			icon: 'sports_soccer',
		},
		{
			name: 'Almohadas de espuma',
			icon: 'hotel',
		},
		{
			name: 'HBO disponible',
			icon: 'tv_gen',
		},
		{
			name: 'Techos altos',
			icon: 'roofing',
		},
		{
			name: 'Baño de mármol',
			icon: 'bathtub',
		},
		{
			name: 'Lista de canales de películas disponibles',
			icon: 'movie',
		},
		{
			name: 'Se aceptan mascotas',
			icon: 'pets',
		},
		{
			name: 'Tina de baño grande',
			icon: 'bathtub',
		},
		{
			name: 'Regadera',
			icon: 'shower',
		},
		{
			name: 'Lavabo en habitación',
			icon: 'kitchen',
		},
		{
			name: 'Habitación insonorizada',
			icon: 'volume_off',
		},
		{
			name: 'Espacio de almacenamiento',
			icon: 'storage',
		},
		{
			name: 'Mesas y sillas',
			icon: 'chair',
		},
		{
			name: 'Teléfono de dos líneas',
			icon: 'phone',
		},
		{
			name: 'Clóset vestidor',
			icon: 'dresser',
		},
		{
			name: 'Lavadora/secadora',
			icon: 'local_laundry_service',
		},
		{
			name: 'Báscula',
			icon: 'fitness_center',
		},
		{
			name: 'Regalo de bienvenida',
			icon: 'card_giftcard',
		},
		{
			name: 'Enchufe eléctrico adicional disponible en escritorio',
			icon: 'power',
		},
		{
			name: 'Cargo no reembolsable por mascotas',
			icon: 'pets',
		},
		{
			name: 'Depósito reembolsable por mascotas',
			icon: 'pets',
		},
		{
			name: 'Tina y regadera separadas',
			icon: 'bathtub',
		},
		{
			name: 'Tipo de entrada a habitación',
			icon: 'door_front',
		},
		{
			name: 'Ventilador de techo',
			icon: 'mode_fan',
		},
		{
			name: 'CNN disponible',
			icon: 'sports_esports',
		},
		{
			name: 'Adaptadores eléctricos disponibles',
			icon: 'power',
		},
		{
			name: 'Desayuno buffet',
			icon: 'breakfast_dining',
		},
		{
			name: 'Habitación accesible',
			icon: 'accessible',
		},
		{
			name: 'Clósets en habitación',
			icon: 'checkroom',
		},
		{
			name: 'Reproductor de DVD',
			icon: 'movie',
		},
		{
			name: 'Mini-refrigerador',
			icon: 'kitchen',
		},
		{
			name: 'Facturación separada para teléfono multilínea',
			icon: 'phone',
		},
		{
			name: 'Sistema de calefacción/refrigeración autocontrolado',
			icon: 'ac_unit',
		},
		{
			name: 'Tostadora',
			icon: 'kitchen',
		},
		{
			name: 'Puerto de datos analógico',
			icon: 'phone',
		},
		{
			name: 'Llamadas por cobrar',
			icon: 'phone',
		},
		{
			name: 'Llamadas internacionales',
			icon: 'phone',
		},
		{
			name: 'Acceso a operadora',
			icon: 'phone',
		},
		{
			name: 'Llamadas interestatales',
			icon: 'phone',
		},
		{
			name: 'Llamadas intraestatales',
			icon: 'phone',
		},
		{
			name: 'Llamadas locales',
			icon: 'phone',
		},
		{
			name: 'Llamadas de larga distancia',
			icon: 'phone',
		},
		{
			name: 'Llamadas asistidas por operadora',
			icon: 'phone',
		},
		{
			name: 'Llamadas con tarjeta de crédito',
			icon: 'phone',
		},
		{
			name: 'Llamadas con tarjeta telefónica',
			icon: 'phone',
		},
		{
			name: 'Llamadas sin cargo',
			icon: 'phone',
		},
		{
			name: 'Adaptadores universales AC/DC',
			icon: 'power',
		},
		{
			name: 'Asiento para tina',
			icon: 'bathtub',
		},
		{
			name: 'Cama con dosel',
			icon: 'hotel',
		},
		{
			name: 'Tazas/cristalería',
			icon: 'kitchen',
		},
		{
			name: 'Centro de entretenimiento',
			icon: 'tv',
		},
		{
			name: 'Habitación familiar/amplia',
			icon: 'family_restroom',
		},
		{
			name: 'Cama hipoalergénica',
			icon: 'hotel',
		},
		{
			name: 'Almohadas hipoalergénicas',
			icon: 'hotel',
		},
		{
			name: 'Lámpara',
			icon: 'light',
		},
		{
			name: 'Desayuno incluido',
			icon: 'breakfast_dining',
		},
		{
			name: 'Desayuno continental incluido',
			icon: 'breakfast_dining',
		},
		{
			name: 'Cena incluida',
			icon: 'dinner_dining',
		},
		{
			name: 'Comida incluida',
			icon: 'lunch_dining',
		},
		{
			name: 'Baño compartido',
			icon: 'bathtub',
		},
		{
			name: 'Teléfono TDD/Teletipo',
			icon: 'phone',
		},
		{
			name: 'Cama de agua',
			icon: 'hotel',
		},
		{
			name: 'Cargo extra por adulto adicional',
			icon: 'person',
		},
		{
			name: 'Cargo extra por niño adicional',
			icon: 'person',
		},
		{
			name: 'Cargo extra por niño en cama plegable',
			icon: 'person',
		},
		{
			name: 'Desayuno americano completo incluido',
			icon: 'breakfast_dining',
		},
		{
			name: 'Futón',
			icon: 'hotel',
		},
		{
			name: 'Cama Murphy',
			icon: 'hotel',
		},
		{
			name: 'Tatamis',
			icon: 'hotel',
		},
		{
			name: 'Cama individual',
			icon: 'hotel',
		},
		{
			name: 'Habitación anexa',
			icon: 'hotel',
		},
		{
			name: 'Periódico gratuito',
			icon: 'newspaper',
		},
		{
			name: 'Suites luna de miel',
			icon: 'hotel',
		},
		{
			name: 'Internet de alta velocidad gratuito en habitación',
			icon: 'wifi',
		},
		{
			name: 'Servicio de limpieza',
			icon: 'house',
		},
		{
			name: 'Conexión para PC en habitación',
			icon: 'computer',
		},
		{
			name: 'Televisión por satélite',
			icon: 'tv',
		},
		{
			name: 'Habitaciones VIP',
			icon: 'hotel',
		},
		{
			name: 'Cargador de celular',
			icon: 'phone',
		},
		{
			name: 'Reproductor DVR',
			icon: 'movie',
		},
		{
			name: 'Estación para iPod',
			icon: 'phone',
		},
		{
			name: 'Centro multimedia',
			icon: 'tv',
		},
		{
			name: 'Panel plug & play',
			icon: 'power',
		},
		{
			name: 'Radio satelital',
			icon: 'radio',
		},
		{
			name: 'Video bajo demanda',
			icon: 'movie',
		},
		{
			name: 'Corredores exteriores',
			icon: 'house',
		},
		{
			name: 'Vista al golfo',
			icon: 'water',
		},
		{
			name: 'Habitación accesible',
			icon: 'accessible',
		},
		{
			name: 'Corredores interiores',
			icon: 'house',
		},
		{
			name: 'Vista a la montaña',
			icon: 'mountain',
		},
		{
			name: 'Vista al océano',
			icon: 'water',
		},
		{
			name: 'Internet de alta velocidad con cargo',
			icon: 'wifi',
		},
		{
			name: 'Wi-Fi de alta velocidad',
			icon: 'wifi',
		},
		{
			name: 'Canales premium de películas',
			icon: 'movie',
		},
		{
			name: 'Pantuflas',
			icon: 'hotel',
		},
		{
			name: 'Kit de primera noche',
			icon: 'hotel',
		},
		{
			name: 'Silla de escritorio',
			icon: 'chair',
		},
		{
			name: 'Colchón pillow top',
			icon: 'hotel',
		},
		{
			name: 'Cama de plumas',
			icon: 'hotel',
		},
		{
			name: 'Edredón',
			icon: 'hotel',
		},
		{
			name: 'Ropa de cama de lujo',
			icon: 'hotel',
		},
		{
			name: 'Canales internacionales',
			icon: 'tv',
		},
		{
			name: 'Despensa',
			icon: 'kitchen',
		},
		{
			name: 'Artículos para lavar platos',
			icon: 'kitchen',
		},
		{
			name: 'Doble lavabo',
			icon: 'bathtub',
		},
		{
			name: 'Espejo de maquillaje con luz',
			icon: 'face',
		},
		{
			name: 'Amenidades de baño mejoradas',
			icon: 'bathtub',
		},
		{
			name: 'Reproductor VCR disponible en recepción',
			icon: 'movie',
		},
		{
			name: 'Agua caliente instantánea',
			icon: 'water',
		},
		{
			name: 'Espacio exterior',
			icon: 'house',
		},
		{
			name: 'Tina Hinoki',
			icon: 'bathtub',
		},
		{
			name: 'Alberca privada',
			icon: 'pool',
		},
		{
			name: 'Televisión HD de pantalla plana',
			icon: 'tv',
		},
		{
			name: 'Ventanas que abren',
			icon: 'window',
		},
		{
			name: 'Tipo de ropa de cama no especificado',
			icon: 'hotel',
		},
		{
			name: 'Cama matrimonial',
			icon: 'hotel',
		},
		{
			name: 'Cama redonda',
			icon: 'hotel',
		},
		{
			name: 'TV',
			icon: 'tv',
		},
		{
			name: 'Child rollaway',
			icon: 'person',
		},
		{
			name: 'DVD player available at front desk',
			icon: 'movie',
		},
		{
			name: 'Video game player:                                      ',
			icon: 'videogame_asset',
		},
		{
			name: 'Video game player available at front desk',
			icon: 'videogame_asset',
		},
		{
			name: 'Dining room seats',
			icon: 'restaurant',
		},
		{
			name: 'Full size mirror',
			icon: 'face',
		},
		{
			name: 'Mobile/cellular phones',
			icon: 'phone',
		},
		{
			name: 'Movies',
			icon: 'movie',
		},
		{
			name: 'Multiple closets',
			icon: 'house',
		},
		{
			name: 'Plates/glassware',
			icon: 'kitchen',
		},
		{
			name: 'Safe large enough to accommodate a laptop',
			icon: 'verified_user',
		},
		{
			name: 'Conteo de hilos de ropa de cama',
			icon: 'hotel',
		},
		{
			name: 'Cortinas opacas',
			icon: 'window',
		},
		{
			name: 'Reproductor Blu-ray',
			icon: 'movie',
		},
		{
			name: 'Dispositivo con mp3',
			icon: 'phone',
		},
		{
			name: 'Sin canales para adultos o bloqueo de canales para adultos',
			icon: 'tv',
		},
		{
			name: 'Habitación antialérgica',
			icon: 'face',
		},
		{
			name: 'Tipo de almohada',
			icon: 'hotel',
		},
		{
			name: 'Área de descanso con sofá/silla',
			icon: 'chair',
		},
		{
			name: 'Área de baño separada',
			icon: 'bathroom',
		},
		{
			name: 'Habilitado para web',
			icon: 'wifi',
		},
		{
			name: 'TV de pantalla ancha',
			icon: 'tv',
		},
		{
			name: 'Otra conexión de datos',
			icon: 'wifi',
		},
		{
			name: 'Línea telefónica facturada por separado',
			icon: 'phone',
		},
		{
			name: 'Tina o regadera separada',
			icon: 'bathtub',
		},
		{
			name: 'Videojuegos',
			icon: 'videogame_asset',
		},
		{
			name: 'Ventilador de techo',
			icon: 'fan',
		},
		{
			name: 'Corral para niños',
			icon: 'baby',
		},
		{
			name: 'Alberca de inmersión',
			icon: 'pool',
		},
		{
			name: 'Películas en DVD',
			icon: 'movie',
		},
		{
			name: 'Filtración de aire',
			icon: 'air',
		},
	]

	return amenity < roomAmenitiesList.length ?
			[roomAmenitiesList[amenity]?.icon, roomAmenitiesList[amenity]?.name]
		:	undefined
}

/**
 * Amenidad → {icon, label} para render. Amadeus manda códigos numéricos
 * (useRoomAmenities → [icon, label]); Hotelbeds manda strings ya legibles
 * ("Wifi", "Aparcamiento") → icono genérico + el texto tal cual. Nunca
 * desreferencia undefined (evita el crash del `useRoomAmenities(+x)![0]`).
 */
export function amenityDisplay(amenity: string | number): {
	icon: string
	label: string
} {
	const code = Number(amenity)
	const mapped = Number.isInteger(code) ? useRoomAmenities(code) : undefined

	return {
		icon: mapped?.[0] ?? 'check_circle',
		label: mapped?.[1] ?? String(amenity),
	}
}
